import { handleActions } from 'redux-actions';
import { Map, List, fromJS } from 'immutable';
// eslint-disable-next-line flowtype/no-weak-types
export var initialState = Map({
    data: List(),
    categoryId: 0,
    error: false,
    loaded: false,
    loadedAll: false,
    loading: false,
    loadingAll: false,
    page: 0,
    pageCount: 0,
    total: 0,
    articlesApiParams: '',
});
export var updateArticle = function (article) { return function (existingArticles) {
    var index = existingArticles.findIndex(function (existingArticle) { return existingArticle.get('id') === article.get('id'); });
    if (index === -1) {
        return existingArticles.push(article);
    }
    return existingArticles.set(index, article);
}; };
var updateArticles = function (articles) { return function (existingArticles) {
    if (existingArticles.size === 0) {
        return articles;
    }
    var newArticles = existingArticles;
    articles.forEach(function (article) {
        newArticles = newArticles.update(updateArticle(article));
    });
    // $FlowIgnoreNextLine
    return newArticles;
}; };
var reducer = handleActions({
    GET_ARTICLE: function (state) { return state.set('loading', true).set('error', false); },
    GET_ARTICLE_COMPLETE: {
        next: function (state, action) {
            return state
                .set('loading', false)
                .set('loaded', true)
                .update('data', updateArticle(action.payload));
        },
        throw: function (state) {
            return state.set('loading', false).set('loaded', false);
        },
    },
    SEARCH_ARTICLE: function (state) { return state.set('loading', true).set('error', false); },
    SCAN_ARTICLE: function (state) { return state.set('loading', true).set('error', false); },
    SEARCH_ARTICLE_COMPLETE: {
        next: function (state, action) {
            return state
                .set('loading', false)
                .set('loaded', true)
                .update('data', updateArticle(action.payload));
        },
        throw: function (state) {
            return state
                .set('loading', false)
                .set('loaded', false)
                .set('error', true);
        },
    },
    GET_ARTICLES: function (state) { return state.set('loadingAll', true); },
    GET_ARTICLES_COMPLETE: {
        next: function (state, action) {
            return state
                .set('loadingAll', false)
                .set('loadedAll', true)
                .set('total', action.payload.totalElements)
                .set('page', action.payload.page)
                .set('pageCount', action.payload.totalPages)
                .update('data', updateArticles(fromJS(action.payload.content)));
        },
        throw: function (state) {
            return state.set('loadingAll', false).set('loadedAll', false);
        },
    },
    ARTICLE_NOT_FOUND: function (state) {
        return state.set('loading', false).set('loaded', true).set('error', true);
    },
    RESET_ARTICLES: function (state) {
        return state
            .set('data', List())
            .set('page', 0)
            .set('total', 0)
            .set('error', false);
    },
    RESET_LOADING: function (state) {
        return state.set('loadingAll', false).set('loading', false).set('loaded', true);
    },
    RESET_ARTICLE_ERROR: function (state) { return state.set('error', false); },
    SET_ARTICLE_PARAMS: function (state, action) {
        return state.set('articlesApiParams', action.payload);
    },
}, initialState);
export default reducer;
